import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedVideos from './components/FeaturedVideos';
import LatestArticles from './components/LatestArticles';
import WhyChooseUs from './components/WhyChooseUs';
import FAQ from './components/FAQ';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <CategorySection />
      <FeaturedVideos />
      <WhyChooseUs />
      <LatestArticles />
      <FAQ />
    </main>
  );
}